(function (root, factory) {
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.DominatorDealerProfile = api;
}(typeof globalThis === 'object' ? globalThis : this, function (root) {
  'use strict';

  function safePublicUrl(value, baseUrl) {
    const text = typeof value === 'string' ? value.trim() : '';
    if (!text) return '';
    try {
      const base = baseUrl || (root.location && root.location.origin);
      const url = new URL(text, base);
      return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
    } catch {
      return '';
    }
  }

  function clearHeroMedia(media, image) {
    if (media) media.hidden = true;
    if (!image) return;
    image.onload = null;
    image.onerror = null;
    if (typeof image.removeAttribute === 'function') image.removeAttribute('src');
    image.alt = '';
  }

  function setHeroMedia(media, image, value, alt, baseUrl) {
    const url = safePublicUrl(value, baseUrl);
    clearHeroMedia(media, image);
    if (!media || !image || !url) return false;

    image.onload = function () {
      media.hidden = false;
    };
    image.onerror = function () {
      clearHeroMedia(media, image);
    };
    image.alt = typeof alt === 'string' ? alt : '';
    image.src = url;
    return true;
  }

  function contactDetails(match) {
    const source = match && typeof match === 'object' ? match : {};
    const phone = typeof source.phone === 'string' ? source.phone.trim() : '';
    const address = typeof source.address === 'string' ? source.address.trim() : '';
    const digits = phone.replace(/\D/g, '');
    const phoneHref = digits.length >= 7
      ? 'tel:' + (phone.startsWith('+') ? '+' : '') + digits
      : '';
    return { phone: phone, phoneHref: phoneHref, address: address };
  }

  function setOptionalText(element, value) {
    if (!element) return false;
    const text = typeof value === 'string' ? value.trim() : '';
    element.textContent = text;
    element.hidden = !text;
    return Boolean(text);
  }

  return {
    contactDetails: contactDetails,
    safePublicUrl: safePublicUrl,
    setHeroMedia: setHeroMedia,
    setOptionalText: setOptionalText,
  };
}));

